import jobsReducer from "./jobsSlice";
import jobReducer from "./jobSlice";

const jobs = {
  jobs: jobsReducer,
  job: jobReducer,
};

export default jobs;
